<template>
  <div>
    <el-button type="text" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        :title="title"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        {{ list }}
      </div>
    </el-drawer>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    info: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.list = _this.info;
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.list = [];
      _this.openStatus = false;
    },
  },
};
</script>